import React, { FC } from 'react';

import Icon from '../../../../Icon';

import { ITimelineItemSliderButton } from './interfaces';

import './styles.scss';

// time line item slider button
const TimelineItemSliderButton: FC<ITimelineItemSliderButton> = ({
  type,
  onClick,
  current = 0,
  count = 0
}) => {
  return (
    <button
      className={`btn time-line-item-slider-button ${type}`}
      data-disabled={type === 'prev'
        ? current <= 0 : current >= (count - 1) || !onClick}
      onClick={onClick}>
      <Icon icon="icon-arrow-dg" />
    </button>
  );
};

export default TimelineItemSliderButton;